import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { ReactComponent as BackIcon } from '@pkg/assets/images/artifacts/back.svg';
import { CircleButton } from '@pkg/components';

import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { getTranslationByArtifactKey } from '@app/helpers';

import { Typography } from '../../../DesignSystem';

import './DetailNavigation.scss';

interface DetailNavigationProps {
    artifactType: ArtifactType;
}

export const DetailNavigation = ({ artifactType }: DetailNavigationProps) => {
    const { t } = useTranslation(['artifacts', 'words']);
    const navigate = useNavigate();

    const handleNavigation = useCallback(
        (path) => {
            navigate(path);
        },
        [navigate],
    );

    return (
        <div className="yat-artifacts__detail-navigation">
            <CircleButton ariaLabel={'back to artifacts'} size="large" onClick={() => handleNavigation('/artifacts')}>
                <BackIcon />
            </CircleButton>
            <Typography type="label" size={16}>
                {getTranslationByArtifactKey(t, artifactType)}
            </Typography>
            <CircleButton ariaLabel={'close'} size="large" onClick={() => handleNavigation('/yativerse')}>
                <CloseIcon />
            </CircleButton>
        </div>
    );
};
